// Types of the timezone plugin setupDayjs installs (main.tsx).
import type {} from "dayjs/plugin/timezone";
import { dayjs, getDefaultTimezone, type Dayjs } from "@marekl/adminer/datetime";

/**
 * Civil dates (issue date, DUZP, due date) travel as "YYYY-MM-DD" and are
 * Czech calendar days, never instants: parsed and printed in Europe/Prague
 * (the default zone set in main.tsx) whatever the browser's own zone.
 */
export function civilToDayjs(s: string | null | undefined): Dayjs | null {
  return s ? dayjs.tz(s, "YYYY-MM-DD", getDefaultTimezone()) : null;
}

export function dayjsToCivil(d: Dayjs | null | undefined): string | null {
  return d ? d.format("YYYY-MM-DD") : null;
}

/** Today in Prague, as the server computes it (models.Today). */
export function todayCivil(): string {
  return dayjs().tz().format("YYYY-MM-DD");
}

/** "15. 03. 2026" (Czech style) for a civil date string; "—" for none. */
export function formatCivil(s: string | null | undefined): string {
  if (!s) return "—";
  const [y, m, d] = s.split("-");
  return `${d}. ${m}. ${y}`;
}

/** The civil date n days after s. */
export function addDaysCivil(s: string, n: number): string {
  const [y, m, d] = s.split("-").map(Number);
  const t = new Date(Date.UTC(y, m - 1, d + n));
  return t.toISOString().slice(0, 10);
}
